import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import store from './store/Store'

// Suppress ResizeObserver loop error (benign error that doesn't affect functionality)
// This error occurs when ResizeObserver can't deliver all notifications in a single animation frame
if (typeof window !== 'undefined') {
  // Use window.onerror to catch the error before React's error overlay
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    if (message && message.includes && message.includes('ResizeObserver loop')) {
      return true; // Prevents the error from propagating
    }
    if (originalOnError) {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
}

ReactDOM.render(
  // <React.StrictMode>

  <Provider store={store} ><App /></Provider>,

  // </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
